import React from "react";
import { Modal, Button, Alert, Row, Col } from "react-bootstrap";
import { FaGoogle, FaUserAstronaut, FaCog, FaSave } from "react-icons/fa";
import "./LoginModal.css";

const LoginModal = ({
  show,
  onHide,
  error,
  onGoogleSignIn,
  isLoading,
  showFeatures = true,
}) => {
  const features = [
    {
      icon: <FaUserAstronaut className="feature-icon" />,
      title: "Multiple Profiles",
      description: "Create unique profiles for different gaming experiences.",
    },
    {
      icon: <FaCog className="feature-icon" />,
      title: "Custom Settings",
      description: "Personalize with themes and avatars for each profile.",
    },
    {
      icon: <FaSave className="feature-icon" />,
      title: "Save Progress",
      description: "Your achievements and progress sync across devices.",
    },
  ];

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="login-modal"
    >
      <Modal.Body>
        <button
          type="button"
          className="btn-close"
          onClick={onHide}
          aria-label="Close"
        ></button>
        <h2 className="modal-title text-center mb-4">Welcome to Star Launch</h2>

        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}
        {!showFeatures && (
          <div
            className="auth-containerz"
            style={{ padding: "1rem", marginBottom: "2rem" }}
          >
            <p
              className="text-center mb-0"
              style={{ color: "rgba(255, 255, 255, 0.9)" }}
            >
              <b>Ready for launch?</b>
              <br />
              Sign in below to start playing.
            </p>
          </div>
        )}

        <Button
          onClick={onGoogleSignIn}
          disabled={isLoading}
          className="signin-button mb-4 mx-auto"
        >
          {isLoading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            <>
              <FaGoogle />
              <span>Continue with Google</span>
            </>
          )}
        </Button>

        {showFeatures && (
          <>
            <div className="features-divider">
              <span>Features & Benefits</span>
            </div>

            <Row className="features-section justify-content-center mt-4">
              {features.map((feature, index) => (
                <Col key={index} md={4} className="text-center mb-3">
                  <div className="feature-icon-wrapper mb-2">
                    {feature.icon}
                  </div>
                  <h5>{feature.title}</h5>
                  <p className="feature-description">{feature.description}</p>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
